<template>
  <div style="padding: 0 20px; background: #fff">
    <a-tabs :activeKey="activeKey" destroyInactiveTabPane @change="changeTab">
      <a-tab-pane v-for="(item, index) in tabList" :key="item.key" :tab="item.tab">
        <CollapseResource
          v-if="item.key !== '16'"
          :title="`${item.key === '4' ? '工作手册' : '课题研究'}`"
          :actionUrl="item.url"
          sortDictCode="research_sort"
          :actionType="item.key"
        />
        <SchemeCard
          v-else
          ref="schemeCardRef"
          :actionUrl="item.url"
          :activeKey="item.key"
          :keysFormArr="item.keysFormArr"
          :cateDictCode="item?.cateDictCode"
        />
      </a-tab-pane>
      <a-button
        v-show="activeKey === '16'"
        type="primary"
        slot="tabBarExtraContent"
        @click="createLeague"
      >
        创建
      </a-button>
    </a-tabs>
  </div>
</template>
<script>
import SchemeCard from '@/comUi/SchemeCard/components/SchemeCard.vue'
// import CreateCourseModal from '@/comUi/CreateCourseModal'
import SchemeDetails from '@/comUi/SchemeCard/components/SchemeDetails'
import CollapseResource from '@/comUi/CollapseResource'

export default {
  name: 'TeacherTraining',
  components: {
    SchemeCard,
    SchemeDetails,
    CollapseResource,
  },
  data() {
    return {
      activeKey: '4',
      // tabList: [
      //   {
      //     tab: '硬件标准化',
      //     key: '0',
      //     url: 'resourceHardware',
      //     dictCode: 'hardware_sort',
      //     cardType: '1',
      //     keysFormArr: [],
      //   },
      //   {
      //     tab: '文化建设',
      //     key: '1',
      //     url: 'resourceCultural',
      //     dictCode: 'cultural_sort',
      //     cardType: '2',
      //     keysFormArr: ['title', 'classify', 'cover', 'file'],
      //   },
      //   {
      //     tab: '制度建设',
      //     key: '2',
      //     url: 'resourceCource',
      //   },
      // ],
      tabList: [
        {
          tab: '学校心理健康工作手册',
          key: '4',
          url: 'resourceResearch',
        },
        {
          tab: '课题研究方法指导',
          key: '5',
          url: 'resourceResearch',
        },
        {
          tab: '全员育人心理培训',
          key: '16',
          url: 'resourceCource',
          cateDictCode: 'course_sort',
        },
      ],
      categoryList: [],
      fitGradeList: [],
      cardList: [],
      cardObj: {},
      queryParam: {
        pageNo: 1,
        pageSize: 12,
      },
      total: 0,
    }
  },
  computed: {
    currTabObj() {
      return this.tabList.find((item) => item.key === this.activeKey)
    },
  },
  created() {
    const backKey = this.$router.history.current.query.activeKey
    if (backKey) {
      this.activeKey = backKey
    }
  },
  methods: {
    changeTab(key) {
      this.activeKey = key
    },
    createLeague() {
      console.log('显示模态框')
      // this.$refs.createCourseModalRef.showModal()
      this.$refs.schemeCardRef[0].showCardModal()
    },
  },
}
</script>
